import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";

export default class PartCategoryManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id
      category_code: "",
      name: "",
      description: "",
      field_control: {
        from_warehouse_id: false,
        location_id: false,
        lot_id: false,
        lot_received_date: false
      },
      is_active: "Active",

      // List Data
      data: [],
      data_categories: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count, data_categories;
    loading(true);

    // Call GET API Part Categories
    let [result, result_categories] = await Promise.all([
      GET("warehouse/part-categories", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        is_active: this.state.filter_status || "",
      }),
      GET("warehouse/part-categories", {
        page_size: 100000,
        page: 0,
        data_search: filter_search || "",
        is_active: this.state.filter_status || "",
      })
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    if (result_categories?.status) {
      data_categories = result_categories.data;
    }

    this.setState({ data: data || [], count, data_categories: data_categories || [] });
    loading(false);
  };

  GetByID = async (uid) => {
    loading(true);
    let result = await GET("warehouse/part-categories", {uid});
    if (result?.status) {
      this.setState({
        ...result.data,
        category_code: result.data.category_code,
        name: result.data.name,
        description: result.data.description,
        is_active: result.data.is_active ? "Active" : "Inactive",
        field_control: result.data.field_control ? {
        from_warehouse_id: result.data.field_control.includes("from_warehouse_id"),
        location_id: result.data.field_control.includes("location_id"),
        lot_id: result.data.field_control.includes("lot_id"),
        lot_received_date: result.data.field_control.includes("lot_received_date")
        }: {
        from_warehouse_id: false,
        location_id: false,
        lot_id: false,
        lot_received_date: false
      },
        modal_update: true,
      });
    }
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      category_code,
      name,
      description,
      is_active,
      field_control,
    } = this.state;

    // Validation
    if (!category_code.trim()) {
      alert("", "warning", t("warning"), t("verify_category_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_category_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);

      let _field_control = [];

      if(field_control.from_warehouse_id) _field_control.push("from_warehouse_id");
      if(field_control.location_id) _field_control.push("location_id");
      if(field_control.lot_id) _field_control.push("lot_id");
      if(field_control.lot_received_date) _field_control.push("lot_received_date");
      
      // Request Body
      let body = {
        company_id,
        category_code,
        name,
        description,
        is_active: is_active === "Active",
        field_control: _field_control
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/part-categories", body)
        : await PUT("warehouse/part-categories/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/part-categories/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      category_code: "",
      name: "",
      description: "",
      is_active: "Active",
      field_control: {
        from_warehouse_id: false,
        location_id: false,
        lot_id: false,
        lot_received_date: false
      }
    });
  };

  toggleField = (field) => {
    this.setState((prevState) => ({
      field_control: {
        ...prevState.field_control,
        [field]: !prevState.field_control[field]
      }
    }));
  };

  render() {
    const {
      data,
      data_categories,
      count,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      category_code,
      name,
      description,
      is_active,
      field_control
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("type_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_part_categories_desc")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_types")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{data_categories.length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                                    {"\uf02b"} {/* Tags icon */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_categories")}</div>
                                    <h4 className="fw-bold text-success mb-0">{data_categories.filter((d) => d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_categories")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{data_categories.filter((d) => !d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_types")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_status")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("part-categories.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_type_master")}
                        </button>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Categories Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("type")}</th>
                                    <th className="py-3 border-0 wpx-300">{t("description")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Category Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf02b"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.category_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Description */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "300px" }}>
                                                {item.description || "-"}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                <ActionIconButton
                                                    label={!can("part-categories.update") ? t("view") : t("edit")}
                                                    icon={!can("part-categories.update") ? ACTION_ICONS.view : ACTION_ICONS.edit}
                                                    variant={!can("part-categories.update") ? "primary" : "warning"}
                                                    onClick={() => {
                                                        this.GetByID(item.uid);
                                                    }}
                                                />
                                                {can("part-categories.delete") && (
                                                <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {count} {t("categories_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT CATEGORY */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? (can("part-categories.update") ? t("edit_category") : t("view")) : t("add_new_type")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                <fieldset disabled={this.state.modal_update && !can("part-categories.update")} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, pointerEvents: this.state.modal_update && !can("part-categories.update") ? "none" : "auto" }}>
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("type_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("type_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder={t("placeholder_type_code_example")}
                                        value={category_code}
                                        onChange={(e) => this.setState({ category_code: e.target.value })}
                                        disabled={modal_update}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("type_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control py-2" placeholder={t("placeholder_type_name_example")} value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="3"
                                        placeholder={t("type_description")}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{""}</span> {t("heading_field_control")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("field_control_desc")}</small>
                            <div className="d-flex flex-column gap-0">
                                {/* Warehouse Toggle */}
                                <div className={"d-flex justify-content-between align-items-center py-3 border-bottom border-light"}>
                                    <div className="pointer" onClick={() => this.toggleField("from_warehouse_id")}>
                                        <div className="fw-bold text-dark text-14 mb-1">{t("field_control_warehouse")}</div>
                                        <div className="text-secondary text-12">{t("field_control_warehouse_desc")}</div>
                                    </div>
                                    <input
                                        type="checkbox"
                                        className="form-check-input pointer"
                                        style={{ width: "20px", height: "20px" }}
                                        checked={field_control?.from_warehouse_id}
                                        onChange={() => this.toggleField("from_warehouse_id")}
                                    />
                                </div>

                                {/* Location Toggle */}
                                <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                                    <div className="pointer" onClick={() => this.toggleField("location_id")}>
                                        <div className="fw-bold text-dark text-14 mb-1">{t("field_control_location")}</div>
                                        <div className="text-secondary text-12">{t("field_control_location_desc")}</div>
                                    </div>
                                    <input
                                        type="checkbox"
                                        className="form-check-input pointer"
                                        style={{ width: "20px", height: "20px" }}
                                        checked={field_control?.location_id}
                                        onChange={() => this.toggleField("location_id")}
                                    />
                                </div>

                                {/* Batch Number Toggle */}
                                <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                                    <div className="pointer" onClick={() => this.toggleField("lot_id")}>
                                        <div className="fw-bold text-dark text-14 mb-1">{t("field_control_lot")}</div>
                                        <div className="text-secondary text-12">{t("field_control_lot_desc")}</div>
                                    </div>
                                    <input
                                        type="checkbox"
                                        className="form-check-input pointer"
                                        style={{ width: "20px", height: "20px" }}
                                        checked={field_control?.lot_id}
                                        onChange={() => this.toggleField("lot_id")}
                                    />
                                </div>

                                {/* Date Toggle */}
                                <div className="d-flex justify-content-between align-items-center py-3">
                                    <div className="pointer" onClick={() => this.toggleField("lot_received_date")}>
                                        <div className="fw-bold text-dark text-14 mb-1">{t("field_control_date")}</div>
                                        <div className="text-secondary text-12">{t("field_control_date_desc")}</div>
                                    </div>
                                    <input
                                        type="checkbox"
                                        className="form-check-input pointer"
                                        style={{ width: "20px", height: "20px" }}
                                        checked={field_control?.lot_received_date}
                                        onChange={() => this.toggleField("lot_received_date")}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Status */}
                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="categoryStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="categoryStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {(this.state.modal_update ? can("part-categories.update") : can("part-categories.create")) && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}